import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Zamówienia',
  buttons: {
    actions: 'Akcje',
    [action_create_dummy_order]: 'Utwórz zamówienie testowe',
    [action_launch_orders_portal_app]: 'Uruchom portal zamówień',
    show_order_details: 'Pokaż szczegóły zamówienia',
    track_order: 'Śledź zamówienie',
    update_dropoff_time: 'Zaktualizuj czas dostawy',
    download_receipt: 'Pobierz paragon',
    open_payment_page: 'Otwórz stronę płatności',
  },
  form: {
    customer_details: {
      placeholder: 'Podaj imię klienta lub numer telefonu',
    },
    amount_min: {
      placeholder: 'Kwota minimalna',
    },
    amount_max: {
      placeholder: 'Kwota maksymalna',
    },
    utm_source: {
      placeholder: 'Podaj źródło utm',
    },
    utm_medium: {
      placeholder: 'Podaj medium utm',
    },
    utm_campaign: {
      placeholder: 'Podaj kampanię utm',
    },
    utm_advertisement_id: {
      placeholder: 'Podaj ID reklamy utm',
    },
  },
  labels: {
    no_orders: 'Brak zamówień',
    total_orders: 'Łączna liczba zamówień',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Odbiór',
    [ORDER_METHODS.delivery]: 'Dostawa',
    [ORDER_METHODS.room_service]: {
      [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Obsługa pokoju',
      [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Obsługa przy stoliku',
    },
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'Oczekujące',
    [ORDER_PAYMENT_STATUSES.paid]: 'Opłacone',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Częściowo zwrócone',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Zwrócone',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'Oczekuje na zatwierdzenie',
      [FULFILLMENT_STATUSES.reviewed]: 'Oczekuje na zatwierdzenie',
      [FULFILLMENT_STATUSES.accepted]: 'W realizacji',
      [FULFILLMENT_STATUSES.preparing]: 'W realizacji',
      [FULFILLMENT_STATUSES.ready]: 'W realizacji',
      [FULFILLMENT_STATUSES.on_delivery]: 'W realizacji',
      [FULFILLMENT_STATUSES.picked]: 'Zrealizowane',
      [FULFILLMENT_STATUSES.rejected]: 'Odrzucone',
      null: 'Nieznany',
      undefined: 'Nieznany',
    },
  },
  tags: {
    dummy: 'TEST',
    pickup: 'Odbiór',
    internal_delivery: 'Dostawa wewnętrzna',
    external_delivery: 'Dostawa zewnętrzna',
    room_service: 'Obsługa pokoju',
    table_service: 'Obsługa przy stoliku',
    scheduled: 'Zaplanowane',
    reward: 'Nagroda',
    mobile: 'Mobile',
    invoice: 'Faktura',
    cash: 'Gotówka',
    rejected_automatically: 'Odrzucone automatycznie',
    rejected_manually: 'Odrzucone ręcznie',
    call_center: 'Call center',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restauracja',
    tags: 'Tagi',
    order_placed: 'Zamówienie złożone',
    ready_at: 'Zamówienie gotowe',
    customer: 'Klient',
    items: 'Pozycje',
    method: 'Metoda',
    payment_status: 'Status płatności',
    fulfillment_status: 'Status',
    total: 'Suma',
    utm_source: 'Źródło UTM',
    utm_medium: 'Medium UTM',
    utm_campaign: 'Kampania UTM',
    utm_advertisement_id: 'ID reklamy UTM',
  },
  metrics: {
    total_orders: 'Łączna liczba zamówień',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_create_dummy_order: 'Nie udało się utworzyć zamówienia testowego',
    dummy_order_created: 'Zamówienie testowe zostało utworzone',
    failed_to_launch_orders_portal_app: 'Nie udało się uruchomić portalu zamówień',
    failed_to_download_receipt: 'Nie udało się pobrać paragonu',
  },
};
